'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "color", "semanticColor", "hasInheritColor", "component", "href", "disabled", "role"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Link } from "./Link.mjs";
/**
 * TextLink is a text-based anchor link that users can follow to another place.
 * It comes in standalone or inline variants.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-textlink--docs) |
 * [Encore site](https://encore.spotify.net/web/components/text#text-links) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TextLink) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=423-1043&t=A8elpsiQkQlIZCx3-1)
 */
export var TextLink = /*#__PURE__*/React.forwardRef(function TextLink(_ref, ref) {
  var children = _ref.children,
    color = _ref.color,
    semanticColor = _ref.semanticColor,
    _ref$hasInheritColor = _ref.hasInheritColor,
    hasInheritColor = _ref$hasInheritColor === void 0 ? false : _ref$hasInheritColor,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    href = _ref.href,
    disabled = _ref.disabled,
    role = _ref.role,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  var _useContext2 = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext2.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/React.createElement(Link, Object.assign({
    component: component,
    isUsingKeyboard: isUsingKeyboard,
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    color: color,
    semanticColor: semanticColor,
    hasInheritColor: hasInheritColor,
    ref: ref,
    href: !disabled ? href : undefined,
    disabled: disabled,
    "aria-disabled": disabled,
    role: disabled && component !== 'button' ? 'link' : role
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.TextLink
  }), children);
});